import { Schema, SchemaTransformation } from 'effect'

export const IntFromString = Schema.NumberFromString.check(Schema.isInt())

export const LenientBooleanFromString = Schema.String.pipe(
  Schema.decodeTo(
    Schema.Boolean,
    SchemaTransformation.transform({
      decode: (value) => value == 'true',
      encode: String
    })
  )
)

export const Base64FromString = Schema.StringFromBase64Url
